import {lastTransactionStatusConstants, transactionConstants} from '../constants';
import {DEFAULT_CURRENCY_CODE} from '../../constants/amount.constants';

const detailsBalanceDetails = {
  currency: DEFAULT_CURRENCY_CODE,
  value: 0,
  isLoaded: false,
  isRequested: false
};

const defaultWireDetails = {
  bic: undefined,
  creationDate: undefined,
  iban: undefined,
  isLoaded: false,
  walletId: undefined
};

const transactionState = {
  balanceDetails: detailsBalanceDetails,
  lastTransaction: null,
  // `lastTransaction` is null for three different reasons — not requested yet, the company has no
  // transactions, the request failed — so this says which. 'idle' until the first response.
  lastTransactionStatus: lastTransactionStatusConstants.IDLE,
  transactions: [],
  wireDetails: defaultWireDetails,
  companyBankingUserId: undefined
};

const transactionReducer = (state = transactionState, action) => {
  const {type, data} = action;
  switch (type) {
    case transactionConstants.GET_TRANSACTION_LIST:
      return {
        ...state,
        transactions: data
      }
    case transactionConstants.GET_LAST_TRANSACTION:
      return {
        ...state,
        lastTransaction: data,
        lastTransactionStatus: lastTransactionStatusConstants.LOADED
      }
    case transactionConstants.GET_LAST_TRANSACTION_FAILED:
      return {
        ...state,
        lastTransaction: null,
        lastTransactionStatus: lastTransactionStatusConstants.FAILED
      }
    case transactionConstants.CLEAR_TRANSACTIONS:
      return {
        ...state,
        transactions: []
      }
    case transactionConstants.SET_WIRE_DETAILS:
      return {
        ...state,
        wireDetails: data
      }
    case transactionConstants.SET_BALANCE_DETAILS:
      return {
        ...state,
        balanceDetails: data
      }
    case transactionConstants.SET_COMPANY_BANKING_USER_ID:
      return {
        ...state,
        companyBankingUserId: data.id
      }
    case transactionConstants.CLEAR_TRANSACTIONS_BANKING_DETAILS:
      return {
        ...state,
        companyBankingUserId: undefined,
        balanceDetails: detailsBalanceDetails,
        lastTransaction: null,
        lastTransactionStatus: lastTransactionStatusConstants.IDLE,
        wireDetails: defaultWireDetails
      }
    default:
      return state;
  }
};

export default transactionReducer;
